import _axios from '@/util/httpConfig.js'
// 获取办事指南
export const getOfficeService = () => {
  const data = {
    "appCode": "APPAFBB8CD316AFF62",
    "contentStatus": "",
    "contentTitle": "",
    "moduleCode": "RESE27B208784B370D",
    "moduleNavCode": "",
    "pageNo": 0,
    "pageSize": 99,
    "status": "",
    "tenantCode": "96F307B9D0EDF9F",
    "typeCode": ""
  }
  return _axios('POST', '/common-content/contentAnnounce/list', '', data)
}
// 获取办事指南详情
export const getOfficeDetailts = (contentCode, tenantCode) => {
  return _axios('GET', `/common-content/contentAnnounce/get?contentCode=${contentCode}&tenantCode=${tenantCode}`)
}
// 获取窗口业务
export const getWindowService = () => {
  const data = {
    "appCode": "APPAFBB8CD316AFF62",
    "moduleCode": "RES256EEFB973E500A",
    "moduleNavCode": "",
    "pageNo": 1,
    "pageSize": 10,
    "picName": "",
    "picStatus": "",
    "status": "",
    "tenantCode": "96F307B9D0EDF9F",
    "typeCode": ""
  }
  return _axios('POST', '/common-content/contentPic/list', '', data)
}
// 获取窗口业务图片
export const getwindowServicePhoto = (picCode, tenantCode) => {
  return _axios('GET', `/common-content/contentPic/get?picCode=${picCode}&tenantCode=${tenantCode}`)
}
export const getContentCode = (moduleCode) => {
  let data = {
    moduleCode,
    tenantCode: '96F307B9D0EDF9F',
    appCode: 'APPAFBB8CD316AFF62'
  }
  return _axios('POST',`/common-content/contentNews/list`, data)
}
// 新闻详情
export const getInfos = (contentCode) => {
  return _axios('GET', `/common-content/contentNews/get?contentCode=${contentCode}&tenantCode=96F307B9D0EDF9F`)
}
// 境外保险
export const getOverseasService = () => {
  return _axios('GET', `/common-content/contentNews/get?contentCode=RESC6DD2AC3CDB40AE&tenantCode=96F307B9D0EDF9F`)
}
// 境外接待
export const getOverseasReception = () => {
  return _axios('GET', `/common-content/contentNews/get?contentCode=RESEEA78C5BE6DE1CB&tenantCode=96F307B9D0EDF9F`)
}
// 航空保险
export const getAviationInsurance = () => {
  return _axios('GET', `/common-content/contentNews/get?contentCode=RESD9B2E8A900696C7&tenantCode=96F307B9D0EDF9F`)
}
// 航空订票
export const getAirlineBooking = () => {
  return _axios('GET', `/common-content/contentNews/get?contentCode=RES7B7CE3B1EBDBB06&tenantCode=96F307B9D0EDF9F`)
}
// 海外猎影
export const getHuntingOverseas = () => {
  return _axios('GET', `/common-content/contentPic/get?picCode=RESB3BEEDE08CDA58F&tenantCode=96F307B9D0EDF9F`)
}
// 咨询图片
export const getConsultThePicture = () => {
  return _axios('GET', `/common-content/contentPic/get?picCode=RESC01DBE2A13AE09B&tenantCode=96F307B9D0EDF9F`)
}
// 咨询信息
export const getConsultTheInfo = () => {
  const data = {
    "appCode": "APPAFBB8CD316AFF62",
    "contentStatus": "",
    "contentTitle": "",
    "moduleCode": "RES10429B203803113",
    "moduleNavCode": "",
    "pageNo": 0,
    "pageSize": 0,
    "status": "",
    "tenantCode": "96F307B9D0EDF9F",
    "typeCode": ""
  }
  return _axios('POST', '/common-content/contentNews/list', '', data)
}
// 咨询信息详情
export const getConsultTheInfoDetail = (contentCode, tenantCode) => {
  return _axios('GET', `/common-content/contentNews/get?contentCode=${contentCode}&tenantCode=${tenantCode}`)
}
// 获取实施情况
export const getApce1 = () => {
  return _axios('GET', '/common-content/contentAnnounce/get?contentCode=RES31C1F39AABB5D80&tenantCode=96F307B9D0EDF9F')
}
// 获取申报情况
export const getApce2 = () => {
  return _axios('GET', '/common-content/contentAnnounce/get?contentCode=RES6E9B433F16A111D&tenantCode=96F307B9D0EDF9F')
}
// 获取计划内容
export const getApce3 = () => {
  return _axios('GET', '/common-content/contentAnnounce/get?contentCode=RESEF666CD1CDC169D&tenantCode=96F307B9D0EDF9F')
}
// 获取网上服务链接
export const getNetService = () => {
  return _axios('GET', '/common-content/contentLink/get?linkCode=RES5520DC89E84EB06&tenantCode=96F307B9D0EDF9F')
}
// 获取领事保护链接
export const getSave = () => {
  return _axios('GET', '/common-content/contentLink/get?linkCode=RES5AF80280C934A2D&tenantCode=96F307B9D0EDF9F')
}
// 获取目的链接
export const getNkeys = () => {
  return _axios('GET', '/common-content/contentLink/get?linkCode=RES312401259C07EE0&tenantCode=96F307B9D0EDF9F')
}
//根据ContentCode获取机构概况
export const getDataByContentCode = (contentCode='RES0CCF8328B69CA6C') => {
  return _axios('GET', `/common-content/contentAnnounce/get?contentCode=${contentCode}&tenantCode=96F307B9D0EDF9F`)
  // return _axios('GET', '/common-content/contentAnnounce?contentCode=RES0CCF8328B69CA6C&tenantCode=96F307B9D0EDF9F')
}
//
//根据picCode获取图片
export const getPicByPicCode = (picCode='RES3F45433B1314A8A',tenantCode='96F307B9D0EDF9F') => {
  return _axios('GET', `common-content/contentPic/get?picCode=${picCode}&tenantCode=${tenantCode}`,'' ,{})
}

// 以fileCode获取文件详情
export const getImgUrl = (data) => {
  // console.log(data);
  return _axios('POST', `/cloud-fastdfs/fastdfs/getFileInfoByFileCode/96F307B9D0EDF9F/APPAFBB8CD316AFF62`,'' , data)
}
// 根据模块id获取图片资源
export const getPic = (moduleCode) => {
  const data = {
    "appCode": "APPAFBB8CD316AFF62",
    "contentStatus": "",
    "contentTitle": "",
    "moduleCode": moduleCode,
    "moduleNavCode": "",
    "pageNo": 0,
    "pageSize": 100,
    "status": "",
    "tenantCode": "96F307B9D0EDF9F",
    "typeCode": ""
  }
  return _axios('POST', '/common-content/contentPic/list', '', data)
}


// WEBPACK FOOTER //
// ./src/api/service.js